import _objectWithoutProperties from '../../node_modules/@babel/runtime/helpers/objectWithoutProperties.js';
import React from 'react';
import Icon from '../components/Icon/Icon.js';

var IconPrint = function IconPrint(_ref) {
  var title = _ref.title,
      filled = _ref.filled,
      otherProps = _objectWithoutProperties(_ref, ["title", "filled"]);

  return /*#__PURE__*/React.createElement(Icon, otherProps, filled ? /*#__PURE__*/React.createElement("svg", {
    title: title,
    viewBox: "0 0 48 48",
    width: "1em",
    height: "1em"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 3h12a3.01 3.01 0 012.995 2.824L33 6v3h9a3.01 3.01 0 012.995 2.824L45 12v21a3.01 3.01 0 01-2.824 2.995L42 36h-6.089l1.036 5.439a3 3 0 01-2.742 3.554L34 45H14a3 3 0 01-2.979-3.358l.032-.203L12.089 36H6a3.01 3.01 0 01-2.995-2.824L3 33V12a3.01 3.01 0 012.824-2.995L6 9h9V6a3.01 3.01 0 012.824-2.995L18 3h12-12zm13.143 24H16.857L14 42h20l-2.857-15zM36 21H12v6h1.803l.107-.561a3 3 0 012.768-2.434l.18-.005h14.285a3 3 0 012.909 2.264l.038.175.107.561H36v-6zM30 6H18v3h12V6z"
  })) : /*#__PURE__*/React.createElement("svg", {
    title: title,
    viewBox: "0 0 48 48",
    width: "1em",
    height: "1em"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 3h12a3.01 3.01 0 012.995 2.824L33 6v3h9a3.01 3.01 0 012.995 2.824L45 12v21a3.01 3.01 0 01-2.824 2.995L42 36h-6.089l1.036 5.439a3 3 0 01-2.742 3.554L34 45H14a3 3 0 01-2.979-3.358l.032-.203L12.089 36H6a3.01 3.01 0 01-2.995-2.824L3 33V12a3.01 3.01 0 012.824-2.995L6 9h9V6a3.01 3.01 0 012.824-2.995L18 3h12-12zm13.143 24H16.857L14 42h20l-2.857-15zM42 12H6v21h6.66l.572-3h-1.279a2.963 2.963 0 01-2.948-2.78L9 27.047V21a3.01 3.01 0 012.824-2.995L12 18h24a3.01 3.01 0 012.995 2.824L39 21v6a3.01 3.01 0 01-2.824 2.995L36 30h-1.232l.572 3H42V12zm-6 9H12v6h1.803l.107-.561a3 3 0 012.768-2.434l.18-.005h14.285a3 3 0 012.908 2.264l.04.175.106.561H36v-6zM30 6H18v3h12V6z"
  })));
};

export default IconPrint;
